import { render, staticRenderFns } from "./DashboardDocumentReminder.vue?vue&type=template&id=4e36661d&"
import script from "./DashboardDocumentReminder.vue?vue&type=script&lang=js&"
export * from "./DashboardDocumentReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports